export default class ToolExecutor {
  constructor({ repository, onBookingComplete, onAdditionalInfoRequired }) {
    this.repository = repository;
    this.onBookingComplete = onBookingComplete;
    this.onAdditionalInfoRequired = onAdditionalInfoRequired;
  }

  async execute(name, args = {}) {
    switch (name) {
      case "find_organizations": {
        const orgs = await this.repository.findOrganizations(args.searchText);
        return { matchedOrganizations: this.repository.serializeOrganizations(orgs) };
      }
      case "get_organization": {
        const org = await this.repository.getOrganization(args.orgId);
        return { organization: this.repository.serializeOrganization(org) };
      }
      case "list_services": {
        const services = await this.repository.listServices(args.productId);
        return { services: this.repository.serializeServices(services) };
      }
      case "list_products": {
        const products = await this.repository.listProducts();
        return { products: this.repository.serializeProducts(products) };
      }
      case "list_schedules": {
        const schedules = await this.repository.listSchedules(args.serviceId, args.productId);
        return { schedules: this.repository.serializeSchedules(schedules) };
      }
      case "list_available_dates": {
        const dates = await this.repository.listAvailableDates(args.scheduleId);
        return { dates };
      }
      case "list_available_slots_by_date": {
        const slots = await this.repository.listAvailableSlotsByDate(args.scheduleId, args.date);
        return { slots: this.repository.serializeSlots(slots, args.scheduleId) };
      }
      case "book_appointment": {
        const result = await this.repository.bookAppointment(args);
        if (result?.status === "ADDITIONAL_INFO_REQUIRED" && this.onAdditionalInfoRequired) {
          setTimeout(()=>this.onAdditionalInfoRequired({ args, result }),3000);
        }
        if (result?.booking?.id && this.onBookingComplete) {
          this.onBookingComplete(result.booking);
        }
        return result;
      }
      case "verify_otp": {
        const result = await this.repository.verifyBookingOTP(args.mobileNumber, args.otp);
        return result;
      }
      default:
        throw new Error(`Unsupported tool: ${name}`);
    }
  }
}
